import React, { useEffect } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { createActorContext } from '@xstate/react'
import multiCartMachine from './multiCartMachine'
import { ActorRefFrom } from 'xstate'

// Cart machine is not needed at server side, initialise with server side state at client side, similar to redux.

export const MultiCartContext = createActorContext(multiCartMachine)

interface ReduxConnectedCartProviderProps {
  children: React.ReactNode
}

// Global reference to cart machine actor for Redux middleware access
let globalCartMachineActor: ActorRefFrom<typeof multiCartMachine> | null = null

export function getCartMachineActor() {
  return globalCartMachineActor
}

// Component to capture the actor reference
function CartMachineActorRegistry({ children }: { children: React.ReactNode }) {
  const actor = MultiCartContext.useActorRef()

  useEffect(() => {
    globalCartMachineActor = actor
    return () => {
      globalCartMachineActor = null
    }
  }, [actor])

  return <>{children}</>
}

export function MultiCartMachineProvider({ children }: ReduxConnectedCartProviderProps) {
  const memberId = useAppSelector((state: App.State) => state.auth.account.memberId)
  const flags = useAppSelector((state: App.State) => state.system.features.flags)

  if (!flags[OptimizelyFeatureFlags.croSharedCarts]) {
    return <>{children}</>
  }

  return (
    <MultiCartContext.Provider options={{ input: { memberId } }}>
      <CartMachineActorRegistry>
        {children}
      </CartMachineActorRegistry>
    </MultiCartContext.Provider>
  )
}
